export const restrictedBaseDomains = [
  "gmail",
  "yahoo",
  "hotmail",
  "outlook",
  "aol",
  "icloud",
  "me.com",
  "googlemail",
  "proton",
  "titenpa",
];
